import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { LinkService, TrackingData } from '@ecm/router';

import { DashboardWarnsViewModel } from '../../../business/model/home/dashboard/DashboardWarnsViewModel';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { ImageUtils } from '../../../utils/image.utils';
import { AdviseWhitelistEclairConstants } from '../../shared/advise-whitelist-eclair.constants';

@Component({
    selector: 'push-warnings[warnings]',
    templateUrl: './push-warnings.component.html',
    styleUrls: ['./push-warnings.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, EcmMaterialModule],
})
export class PushWarningsComponent implements OnInit {
    private readonly linkService = inject(LinkService);
    private readonly trackingService = inject(TrackingService);

    @Input()
    public warnings!: DashboardWarnsViewModel[];

    @Input()
    public isMobile: boolean;

    @Input()
    public isSoshBrand: boolean;

    protected readonly AdviseWhitelistEclairConstants = AdviseWhitelistEclairConstants;
    public zid!: string;
    public isEclair!: boolean;

    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();
        if (this.warnings) {
            for (const warning of this.warnings) {
                if (warning.link) {
                    warning.href = this.linkService.getLinkSync(warning.link);
                }
                this.zid = this.trackingService.getTrackNamePerType(warning.type, this.isMobile, this.isSoshBrand);
            }
        }
    }

    public openLink(warning: DashboardWarnsViewModel) {
        this.linkService.openLink(
            warning.link,
            Object.assign(new TrackingData(), {
                cappingTracking:
                    warning.advTracker && warning.advTracker.length > 0
                        ? {
                              advTracker: warning.advTracker,
                              code: warning.code,
                              cid: warning.cid,
                          }
                        : null,
                tmsTracking: {
                    trackedPage: TrackedPage.dashboard,
                    trackingArea: 'care_hp_top_alerte',
                    trackingName: warning.code,
                },
            }),
        );
    }

    public getImgFormat(imgurl: string) {
        return ImageUtils.transformUrl(imgurl, '32');
    }
}
